import axios from 'axios';
import { GET_AIPORT_ITEMS, GET_REGIONS } from './define';

export const getRegion = token => {
    return axios.get(GET_REGIONS, {
        params: {
            token
        },
        withCredentials: false
    });
}

export const getAirport = (token) => {
    return axios.get(GET_AIPORT_ITEMS, {
        params: {
            token
        }, 
        withCredentials: false
    });
}

